import React from "react";
import { Helmet } from "react-helmet-async";
import "./aboutPartners.css";
import { partnersList } from "./aboutPartnersList";
import AboutPartnerList from "./AboutPartnerList/AboutPartnerList";

const AboutPartners = () => {
  const cegesPartnerek = partnersList.filter(
    (partner) => partner.typeOfPartnership === "céges ügyfél"
  );
  const maganrendeloPartnerek = partnersList.filter(
    (partner) => partner.typeOfPartnership === "magánrendelők"
  );

  // Create structured data for partners
  const partnersStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    name: "Bálint Analitika Laboratórium",
    url: "https://balintanalitika.hu/orvosdiagnosztika/rolunk/partnereink",
    description:
      "A Bálint Analitika laboratórium partnerei között számos magánrendelő és céges partner található Budapest XI. kerületében és országszerte.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Kondorfa utca 6.",
      addressLocality: "Budapest",
      postalCode: "1116",
      addressRegion: "XI. kerület",
      addressCountry: "HU",
    },
    member: partnersList.map((partner) => ({
      "@type": "Organization",
      name: partner.companyName,
      url: partner.companyLink || "https://balintanalitika.hu",
    })),
  };

  return (
    <>
      <Helmet>
        <title>
          Partnereink | Bálint Analitika Laboratórium | Budapest XI. kerület
        </title>
        <meta
          name="description"
          content="Ismerje meg a Bálint Analitika laboratórium szakmai partnereit! Együttműködő magánrendelők és céges partnereink, akikkel a magas szintű orvosi diagnosztikát biztosítjuk."
        />
        <meta
          name="keywords"
          content="Bálint Analitika partnerek, laborvizsgálat együttműködés, orvosi laboratórium partnerek, magánrendelő együttműködés, céges laborvizsgálat"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/rolunk/partnereink"
        />
        <script type="application/ld+json">
          {JSON.stringify(partnersStructuredData)}
        </script>
      </Helmet>
      <main className="about-partners navbar-margin">
        <h1 className="about-partner-container about-heading">
          Legyen Ön is a partnerünk!
        </h1>
        <section className="about-partner-container about-partners-join-section">
          <div className="about-partner-container about-partners-join-box">
            <p className="about-partners-text">
              Örömmel várjuk Önt és vállalkozását a partneri programunkban.
              Célunk az egészségügyi diagnosztika terén való együttműködés a
              minőség és innováció jegyében. Lássa partnereinket alább, és ha
              szeretne csatlakozni hozzánk, kattintson a 'Csatlakozás' gombra
              lent.
            </p>
            <a
              href={`mailto:${"partner@balintanalitika.hu"}`}
              className="about-partners-join-button btn btn-lg btn--full"
            >
              Csatlakozás
            </a>
          </div>
        </section>
        <section
          className="about-partner-section"
          aria-labelledby="business-partners"
        >
          <AboutPartnerList
            partners={cegesPartnerek}
            title="Céges partnereink"
          />
        </section>
        <section
          className="about-partner-section"
          aria-labelledby="clinic-partners"
        >
          <AboutPartnerList
            partners={maganrendeloPartnerek}
            title="Magánrendelő partnerek"
          />
        </section>
      </main>
    </>
  );
};

export default AboutPartners;
